
AddPageSwapTrigger(function() {
    var loaded = false;
    var renew = false;
    var thecode = '';

    var loadDiscountCode = function(el) {
        var type = el.data('value');
        var datacode = el.data('thecode');

        if(typeof datacode != 'undefined' && !loaded) {
            code = datacode.toString();
            if (code.length > 0) {
                thecode = datacode
                loaded = true;
            }
        }
        else if(typeof type != 'undefined' && type.length && !loaded) {
            el.val(sk_i18n.msgFetchingCode);

            var url = '/live/codes/get/' + type;

            if(renew) {
                renew = false;
                url += '/renew';
            }

            $.ajax({
                method: 'GET',
                url:  url,
                async: false,
                success: function (data) {
                    if (data.length > 0) thecode = data;
                    else el.val(sk_i18n.msgFetchingCodeFailed);
                    loaded = true;
                }
            })
        }
        else {
            thecode = el.val();
        }
        return thecode;
    }

    var copyDiscountCode = function(el, callback) {
        loadDiscountCode(el);
        copyToClipboardWithAlert(thecode, function() {
            el.val(maskDiscountCode(thecode));
            callback();
        });
    }

    $('.discount_code').click(function() {
        var el = $(this);

        loadDiscountCode(el);
    });

    $('.copy_discount_code').click(function(e) {
        e.preventDefault();

        var $a = $(this);
        var el = $(this).closest('div.modal').find('.discount_code');

        copyDiscountCode(el, function() {
            if(!window.open($a.attr('href'))) {
                document.location.href = $a.attr('href');
            }
        });
    });

    $('.generate_discount_code').click(function(e) {
        e.preventDefault();

        var $a = $(this);
        var $modal = $(this).closest('div.modal');
        var el = $modal.find('.discount_code');

        $modal.find('.unlock_discount_code').remove();
        $modal.find('.copy_discount_code').show();
        $modal.find('.renew_discount_code').show();
        $modal.find('#renew_discount_code').show();

        copyDiscountCode(el, function() {
            if(!window.open($a.attr('href'))) {
                document.location.href = $a.attr('href');
            }
        });
    });

    $('.renew_discount_code').click(function(e) {
        e.preventDefault();

        renew = true;
        loaded = false;
        thecode = '';

        var $a = $(this);
        var $modal = $(this).closest('div.modal');
        var el = $modal.find('.discount_code');

        $modal.find('.unlock_discount_code').remove();
        $modal.find('.copy_discount_code').show();

        copyDiscountCode(el, function() {
            if(!window.open($a.attr('href'))) {
                document.location.href = $a.attr('href');
            }
        });
    });

});
